module.exports = __webpack_public_path__ + "img/to_slide_or_not_to_slide.ccc3f572.jpg";